module.exports = __webpack_public_path__ + "img/synapse-homepage3.866d09c3.png";